import * as React from 'react';
import * as styles from './SelectUserType.css';
import { EUserType } from '../../../../constants/requestDemand';
import { mergeStyles } from '@cian/utils/lib/shared/style';

export interface IUserTypeProps {
  value: EUserType;
  name: string;

  onChange(e: React.SyntheticEvent<HTMLInputElement>): void;
}

const labels = {
  [EUserType.USER]: 'Я ищу объект',
  [EUserType.HOME_OWNER]: 'Я собственник',
};

export const SelectUserType: React.FC<IUserTypeProps> = ({ value, name, onChange }) => (
  <div className={styles['container']}>
    {[EUserType.USER, EUserType.HOME_OWNER].map(type => (
      <label key={type} {...mergeStyles(styles['label'], value === type && styles['selected'])}>
        <input className={styles['radio']} name={name} type="radio" value={type} onChange={onChange} />
        <div className={styles['control']}>{labels[type]}</div>
      </label>
    ))}
  </div>
);

SelectUserType.displayName = 'SelectUserType';
